import { useTranslation } from 'react-i18next';

import { ScheduleInstallationFailure } from '@app/components/ScheduleInstallation';

export interface ScheduleFailureProps {
  goToOverview: () => void;
}

export const ScheduleFailure = ({ goToOverview }: ScheduleFailureProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'ErrorAppointmentSchedule',
  });

  return <ScheduleInstallationFailure handleBackNavigation={goToOverview} title={t('title')} />;
};
